import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectDefaultModDetails,
  selectIsEditExistingMod,
  selectIsEditMod,
} from 'store/redux-store/placement-mods/selectors';
import { placementModsAction } from 'store/redux-store/placement-mods/slice';
import { AdultsInfoGrid } from './AdultsInfoGrid';
import { ChildrenGrid } from './ChildrenGrid';
import { PetsGrid } from './PetsGrid';
import { preferencesModStyles } from './PreferencesMod.styles';

export const TravelerInfo = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedModsDetails = useSelector(selectDefaultModDetails);
  const isModEdit = useSelector(selectIsEditMod);
  const isEditExistingMod = useSelector(selectIsEditExistingMod);
  const { classes } = preferencesModStyles();

  useEffect(() => {
    if (selectedModsDetails && (isModEdit || isEditExistingMod))
      dispatch(placementModsAction.business_setEditPreferenceRows(selectedModsDetails));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedModsDetails, isModEdit]);

  return (
    <>
      <div className={classes.headingSpace}>
        <Typography component="span" className={classes.heading}>{`${t(
          'placement.placementMods.travelerInfo',
        )}`}</Typography>
      </div>
      <Box className={classes.containerItem}>
        <Typography component="span" className={classes.keyFactslabel}>
          {t('placement.placementMods.keyFacts')}
        </Typography>
        <Typography component="span" className={classes.keyFacts}>
          {selectedModsDetails.keyFacts || '--'}
        </Typography>
      </Box>
      <Grid>
        <AdultsInfoGrid adultsTableInfo={selectedModsDetails.adults} />
      </Grid>
      <Grid className={classes.tableSpacing}>
        <ChildrenGrid childrenTableInfo={selectedModsDetails.children} />
      </Grid>
      <Grid className={classes.tableSpacing}>
        <PetsGrid petsTableInfo={selectedModsDetails.pets} />
      </Grid>
    </>
  );
};
